import { ROUTES_ADD_RESULTS } from '@/constants/routes';

export default {
    path: '/session/:sessionId/add-results',
    name: ROUTES_ADD_RESULTS,
    component: () => import(/* webpackChunkName: 'add-results' */ '@/views/AddResults.vue')
};
